import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import { AuthWrapper } from "../../../../components/AuthWrapper/AuthWrapper";
import InputField from "../../../../components/Controls/Input/Input";
import { agenciesResendOTPRequest } from "../../../../store/authentication/actions";
import { ButtonComponent } from "../../../../components/Controls/Button/Button";
import Spinner from "../../../../components/Spinner/Spinner";
import { EMPLOYEE_ID_PATTERN } from "../../../../utils/validations";
import "./forgetPassword.scss";

const AgenciesForgetPassword = ({ intl: { messages } }) => {
  const loader = useSelector((state) => state.loader);
  const dispatch = useDispatch();

  const loginSchema = yup.object().shape({
    username: yup
      .string()
      .matches(EMPLOYEE_ID_PATTERN, messages.auth.errors.userNameError)
      .max(50, messages.auth.errors.userNameLength)
      .required(messages.auth.errors.required),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
    },
    validationSchema: loginSchema,
    onSubmit: (values) => {
      dispatch(agenciesResendOTPRequest(values));
      localStorage.setItem("todo", "forget_password");
    },
  });

  const renderFormContent = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: 'calc(100% - 35px)' }}>
        <div className="forgetPassword-form" style={{ width: '100%' }} >
          <div className="forgetPassword-form_logo"></div>
          <h4 className="forgetPassword-form_form-header">
            {messages.auth.forgetPassword}
          </h4>
          <p className="forgetPassword-form_form-content">
            {messages.auth.forgetPasswordFormHint}
          </p>
          <form onSubmit={formik.handleSubmit}>
            <InputField
              isRequired={true}
              id="username"
              name="username"
              label={messages.auth.labels.userName}
              value={formik.values.username}
              onChange={formik.handleChange}
              error={formik.touched.username && Boolean(formik.errors.username)}
              helperText={formik.touched.username && formik.errors.username}
              placeholder={messages.auth.placeholders.userName}
            />
            <ButtonComponent
              content={
                <>{loader ? <Spinner color={"white"} /> : messages.auth.send}</>
              }
              variant="contained"
              classes="mx-auto w-100 my-2 form-submit-btn"
              handleClick={formik.handleSubmit}
              color="primary"
            />
          </form>
        </div>
      </div>
    );
  };

  return (
    <AuthWrapper
      content={renderFormContent()}
      handleSubmit={formik.handleSubmit}
    />
  );
};

export default injectIntl(AgenciesForgetPassword);
